import { slick } from 'slick-carousel'
import $ from 'jquery'

$(document).ready(() => {
  const slideToShow = (window.employeesCount > 4) ? 4 : window.employeesCount

  $('#home-carousel').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    slidesToShow: slideToShow,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 413,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  })
})
